import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import AuditProperties from './AuditProperties';
import { formatHours } from '../../../../utils/dates';

export default function ActivityDetails({ activities }) {
  const mapActivityData = activity => {
    return (
      <Grid item container xs={12} sm={12} key={activity.id} className="info-wrapper">
        <Grid item xs={6} sm={6}>
          {activity.name}
        </Grid>
        <Grid item xs={2} sm={2}>
          {formatHours(activity.duration)}
        </Grid>
        <Grid item xs={2} sm={2}>
          {activity.ragStatus.name}
        </Grid>
        <Grid item xs={2} sm={2}>
          {activity.band.name}
        </Grid>
        <br /> <br />
        {activity.auditEntryProperties && <AuditProperties props={activity.auditEntryProperties} />}
      </Grid>
    );
  };

  return (
    <div className="activities-table-wrapper">
      <div className="activities-table-head">
        <Grid container xs={12} sm={12}>
          <Grid item xs={6} sm={6}>
            <p>Activity name</p>
          </Grid>
          <Grid item xs={2} sm={2}>
            <p>Duration</p>
          </Grid>
          <Grid item xs={2} sm={2}>
            <p>RAG status</p>
          </Grid>
          <Grid item xs={2} sm={2}>
            <p>Required grade</p>
          </Grid>
        </Grid>
      </div>
      <div className="content">
        {activities !== null && (
          <Box>
            <Grid container spacing={0}>
              {activities.map(mapActivityData)}
            </Grid>
          </Box>
        )}
      </div>
    </div>
  );
}
